// extracted by mini-css-extract-plugin
export var accountCompletion = "account-completion-module--accountCompletion--b30c7";
export var addressBox = "account-completion-module--addressBox--82223";
export var buttonBox = "account-completion-module--buttonBox--ea856";
export var cityBox = "account-completion-module--cityBox--ed763";
export var content = "account-completion-module--content--5459b";
export var contractNumberContainer = "account-completion-module--contractNumberContainer--abb00";
export var nameBox = "account-completion-module--nameBox--cd7ae";